import React from "react";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import * as d from "../../reducers/domainReducer";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import * as msgs from "../../constants/textConstants";
import { Typography, Icon, Divider, LinkText } from "../ecosystem";
import PharmacyTileContact from "./PharmacyTileContact";
import ErrorLoadingTileMessage from "../common/ErrorLoadingTileMessage";

class UnLinkedTransfer extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Rx.UnLinkedTransfer.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        if (typeof window === 'undefined') {
            return null;
        }

        const { unlinkedTransferData, archiveUnlinkedRxTransfer, currentPharmacyUser, serverData } = this.props;

        const transferRXCount = (unlinkedTransferData && unlinkedTransferData.RxList && unlinkedTransferData.RxList.length) ? unlinkedTransferData.RxList.length : 0;
        const message = `Transferring ${transferRXCount} prescription${transferRXCount > 1 ? 's' : ''} to ${(currentPharmacyUser && currentPharmacyUser.firstName) ? currentPharmacyUser.firstName : 'your'} new pharmacy home:`

        let rxTransfer = { href: serverData.pharmacyAppUrl + 'nonBswTransfer' };
        if (window.location.href.toLowerCase().indexOf('localhost') > -1) {
            rxTransfer = { to: { pathname: '/pharmacyNonBswTransfer' } };
        }

        return ( unlinkedTransferData 
            ? <div className="link-pharmacy-transfer">
                <div className="row link-pharmacy-transfer__status">
                    <div className="col-12">
                        <div className="transfer-status__heading">
                            {unlinkedTransferData.Status === 'Declined'
                                ? <div className="transfer-status__icon"><Icon name="exclamation" color="$color-system-b1" /></div> 
                                : <div className="transfer-status__share-icon"><Icon name="share" /></div>
                            }
                            <Typography type="body-02" bold tag="div" color="$color-primary-a2">
                                Transfer {unlinkedTransferData.Status}
                            </Typography>
                        </div>
                        <Typography type="body-01" tag="div">
                            {unlinkedTransferData.Status === 'Declined'
                                ? unlinkedTransferData.Message
                                : message
                            }
                        </Typography>
                    </div> 
                </div>
                <div className="row link-pharmacy-transfer__footer">
                    {unlinkedTransferData.Status === 'Declined'
                        ? <>
                            <div className="col-6">
                                <LinkText
                                    as={<button type='button'></button>}
                                    onClick={() => archiveUnlinkedRxTransfer()}
                                    typographyType="body-02"
                                >Dismiss</LinkText>
                            </div>
                            <div className="col-6 text-right">
                                <LinkText
                                    {...rxTransfer}
                                    typographyType="body-02"
                                >Try Again</LinkText>
                            </div>
                            </>
                        : <div className="col-12">
                            <div className="pharmacy-name">
                                <Typography type="body-02" bold>
                                    {unlinkedTransferData.BswPharmacy?.Name}
                                </Typography>
                            </div>
                            <Divider mLeft="none" mRight="none" />
                            <PharmacyTileContact
                                address={unlinkedTransferData.BswPharmacy?.Address}
                                phone={unlinkedTransferData.BswPharmacy?.PhoneNumber}
                            />
                        </div>
                    }
                </div>
            </div>
            : <ErrorLoadingTileMessage />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        unlinkedTransferData: state.pharmacy.unLinkedRxTransfer,
        isLoggedIn: state.sso.isLoggedIn,
        userDetails: state.sso.userDetails,
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        currentUser: d.hydrateProxyUser(state.domain.cu),
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
        serverData: state.session.serverData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        archiveUnlinkedRxTransfer: () => {
            dispatch({
                type: types.ARCHIVE_UNLINKED_RX_TRANSFER_START
            });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UnLinkedTransfer);